import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CacheService {

  constructor() {}

  getCurrentDateTime(): number {
    return new Date().getTime(); // Returns time in milliseconds
  }

  checkedIfExpired(savedTime: number, expiredInSeconds): boolean {
    const currentDate = new Date().getTime(); 

    const expiryDate = savedTime + ( expiredInSeconds * 1000);
    // Check if current time is passed expiryDate
    return currentDate > expiryDate;
  }

  getCachedData(storageKey: string) {
    const cachedDataString = localStorage.getItem(storageKey);
    if (cachedDataString) {
      return JSON.parse(cachedDataString);
    }
    return null;
  }

  saveToLocalStorage(storageKey:string, data: any) {
    const cacheData = {
      data,
      timestamp: this.getCurrentDateTime(),
    };
    localStorage.setItem(storageKey, JSON.stringify(cacheData));
  }
}